<template>
    <main class="flex-1 relative overflow-y-auto focus:outline-none bg-stage-background" tabindex="0">
        <div class="min-h-full flex flex-col">
            <div class="w-full my-auto py-6">
                <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                    <div class="flex flex-wrap items-center gap-2">
                        <h1 class="py-0.5 text-3xl font-semibold text-gray-900">{{ $t('Dashboard') }}</h1>
                        <div class="stage-shortcut-badges">
                            <span
                                v-for="badge in $navigationShortcutBadges('workspace_dashboard')"
                                :key="badge.key"
                                :title="badge.title || 'Shortcut'"
                                class="stage-shortcut-badge"
                            >
                                <svg-vue class="stage-shortcut-badge-icon" icon="font-awesome.solid.command"></svg-vue>
                                {{ badge.label }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                    <div v-if="dashboardNotice.show" class="py-6">
                        <div class="w-full rounded bg-white px-6 py-6 shadow sm:rounded-lg">
                            <div class="flex items-center justify-center gap-2 text-sm font-medium text-center leading-6 text-gray-700 whitespace-pre-line">
                                <svg-vue class="h-4 w-4 flex-shrink-0 text-gray-400" icon="font-awesome.regular.circle-info"></svg-vue>
                                <span>{{ dashboardNotice.text }}</span>
                            </div>
                        </div>
                    </div>
                    <template v-if="showDashboardContent">
                        <div class="py-4">
                            <stats/>
                        </div>
                        <div v-if="showHistorySection" class="py-4">
                            <h1 class="py-0.5 text-2xl font-semibold text-gray-900 mb-4">{{ $t('History') }}</h1>
                            <opened-tickets/>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import Stats from "@/components/widgets/stats";
import OpenedTickets from "@/components/widgets/opened-tickets";
import {resolveStoreAccess} from "@/utils/access-context";

export default {
    name: "home",
    data() {
        return {
            dashboardNotice: {
                enabled: false,
                text: '',
                show: false,
            },
        };
    },
    mounted() {
        this.getDashboardNotice();
    },
    computed: {
        accessContext() {
            return resolveStoreAccess(this.$store);
        },
        showDashboardContent() {
            return !!this.accessContext.modules.tickets
                || !!this.accessContext.modules.positions
                || !!this.accessContext.modules.file_manager;
        },
        showHistorySection() {
            return !!this.accessContext.modules.tickets
                || !!this.accessContext.modules.positions;
        },
    },
    methods: {
        getDashboardNotice() {
            const self = this;

            axios.get('api/workspace/stats/dashboard-notice').then(function (response) {
                self.dashboardNotice = {
                    enabled: !!response.data.enabled,
                    text: response.data.text || '',
                    show: !!response.data.show,
                };
            }).catch(function () {
                self.dashboardNotice = {
                    enabled: false,
                    text: '',
                    show: false,
                };
            });
        },
    },
    metaInfo() {
        return {
            title: this.$i18n.t('Dashboard')
        }
    },
    components: {OpenedTickets, Stats}
}
</script>
